import SettingsIcon from '@material-ui/icons/Settings';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectArrayInput,
    CustomSelectInput,
} from 'candy-commons-components';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    ArrayInput,
    BooleanInput,
    Edit,
    ImageField,
    NumberInput,
    SimpleForm,
    SimpleFormIterator,
    SimpleShowLayout,
    TextInput,
    required,
    useTranslate,
    FormDataConsumer,
} from 'react-admin';
import CustomToolbar from '../../components/CustomToolbar';
import ImageInput from '../../components/ImageInput';
import display from '../../data/display.json';
import loadingType from '../../data/loadingType.json';
import type_ from '../../data/type.json';
import options from './applianceWakeUp.mock';
import EnrollmentSection from '../../components/enrollmentSection';
import { useSelector } from 'react-redux';
import dryingTechnology from '../../data/dryingTechnology.json';
import installationType from '../../data/installationType.json';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
    getSeriesVersion,
} from '../../selectors/cmsConfig';
const useStyles = makeStyles({
    width: {
        width: '100% !important',
    },
});
const ApplianceWakeUpEdit = ({ permissions = {}, ...props }) => {
    const translation = useTranslate();
    const classes = useStyles();
    const applianceTypes = useSelector(getApplianceTypes);
    const brands = useSelector(getBrands);
    const series = useSelector(getSeries);
    const seriesVersion = useSelector(getSeriesVersion);
    const isEditDisabled = !permissions['appliance-wake-up']?.update;
    const { id } = props;
    const breadcrumbsData = [
        {
            text: translation('resources.appliance-wake-up.name'),
            url: 'appliance-wake-up',
            icon: <SettingsIcon />,
        },
        {
            text: id,
            url: '',
        },
    ];
    const enrollmentSection = useMemo(
        () =>
            ({ formData, ...rest }) => {
                return (
                    <EnrollmentSection>
                        {({
                            resetGestureDisabled,
                            easyEnrollmentDisabled,
                            standardEnrollmentDisabled,
                            singlePairingDisabled,
                            updateCredentialsDisabled,
                        }) => (
                            <>
                                <BooleanInput
                                    initialValue={false}
                                    source="resetGesture"
                                    label="Reset gesture"
                                    disabled={
                                        resetGestureDisabled || isEditDisabled
                                    }
                                />
                                <BooleanInput
                                    initialValue={false}
                                    source="easyEnrollment"
                                    label="Easy enrollment"
                                    disabled={
                                        easyEnrollmentDisabled || isEditDisabled
                                    }
                                />
                                <BooleanInput
                                    initialValue={false}
                                    source="standardEnrollment"
                                    label="Standard enrollment"
                                    disabled={
                                        standardEnrollmentDisabled ||
                                        isEditDisabled
                                    }
                                />
                                <BooleanInput
                                    initialValue={false}
                                    disabled={
                                        singlePairingDisabled || isEditDisabled
                                    }
                                    source="singlePairing"
                                    label="Single pairing"
                                />
                                <BooleanInput
                                    initialValue={false}
                                    disabled={
                                        updateCredentialsDisabled ||
                                        isEditDisabled
                                    }
                                    source="updateCredentials"
                                    label="Update Credentials"
                                />
                            </>
                        )}
                    </EnrollmentSection>
                );
            },
        [isEditDisabled]
    );
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit {...props}>
                <SimpleForm
                    toolbar={
                        <CustomToolbar
                            permissions={permissions}
                            isEditDisabled={isEditDisabled}
                        />
                    }
                >
                    <ContainerFieldsList>
                        <CustomSelectInput
                            source="applianceType"
                            choices={applianceTypes}
                            validate={required()}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="brand"
                            choices={brands}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="series"
                            choices={series}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            choices={seriesVersion}
                            source="seriesVersion"
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="loadingType"
                            choices={loadingType}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            source="installationType"
                            choices={installationType}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            label="Drying Technology"
                            source="dryingTechnology"
                            disabled={isEditDisabled}
                            choices={dryingTechnology}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="type"
                            choices={type_}
                            disabled={isEditDisabled}
                        />
                        <CustomSelectArrayInput
                            allowEmpty
                            source="display"
                            choices={display}
                            disabled={isEditDisabled}
                        />
                        <TextInput
                            source="title"
                            label="title"
                            disabled={isEditDisabled}
                            validate={required()}
                        />
                        <TextInput
                            source="description"
                            label="description"
                            disabled={isEditDisabled}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="options"
                            label="Enrollment type"
                            choices={options}
                            disabled={isEditDisabled}
                            translateChoice={false}
                        />
                    </ContainerFieldsList>
                    <ContainerFieldsList>
                        <FormDataConsumer>{enrollmentSection}</FormDataConsumer>
                    </ContainerFieldsList>
                    <hr className={classes.width} />
                    <ArrayInput source="steps" disabled={isEditDisabled}>
                        <SimpleFormIterator
                            getItemLabel={(index) => `${index + 1}-key`}
                        >
                            <TextInput
                                source="stepTitle"
                                label="Step title"
                                validate={required()}
                            />
                            <TextInput
                                source="stepSubtitle"
                                label="Step subtitle"
                            />
                            <SimpleShowLayout>
                                <ImageField source="imagePath" />
                            </SimpleShowLayout>
                            {/* <TextInput label="title" source="title" /> */}
                            <TextInput
                                label="description"
                                source="description"
                            />
                            <BooleanInput
                                initialValue={false}
                                source="standard"
                                label="Standard flow (wifi)"
                            />
                            <NumberInput source="delay" label="Delay" />
                            {!isEditDisabled && (
                                <ImageInput
                                    source="imagePath"
                                    label="Image"
                                    accept="image/*"
                                    placeholder={<p>Drop your file here</p>}
                                >
                                    <ImageField source="src" title="title" />
                                </ImageInput>
                            )}
                        </SimpleFormIterator>
                    </ArrayInput>
                </SimpleForm>
            </Edit>
        </>
    );
};
export default ApplianceWakeUpEdit;
